<template>
  <div>
    <v-row>
      <v-col class="d-flex" cols="1">
        <v-btn class="ma-auto" color="primary" @click="setToday">Dzisiaj</v-btn>
      </v-col>
      <v-col class="d-flex" cols="1" offset="3">
        <v-btn class="ma-auto" icon @click="prev">
          <v-icon>fa-arrow-left</v-icon>
        </v-btn>
      </v-col>
      <v-col class="d-flex" cols="1">
        <span v-if="isInitialized" class="ma-auto">{{ $refs.calendar.title }}</span>
      </v-col>
      <v-col class="d-flex" cols="1">
        <v-btn class="ma-auto" icon @click="next">
          <v-icon>fa-arrow-right</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="3" offset="2">
        <v-select v-model="type" :items="types" label="Wyświetlanie"></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
      <slot name="middleRow">
      </slot>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-calendar
            ref="calendar"
            v-model="focus"
            :event-color="getEventColor"
            :events="events"
            :type="type"
            color="primary"
            @click:date="clickDate"
            @click:event="clickEvent"
            @click:more="clickMore"
            @click:day="clickDay"
            :weekdays="weekdays"
        >
        </v-calendar>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    events: Array
  },
  data() {
    return {
      weekdays: [1,2,3,4,5,6,0],
      isInitialized: false,
      focus: '',
      type: 'month',
      types: [
        {
          text: "Dzień",
          value: "day"
        }, {
          text: "Tydzień",
          value: "week"
        },
        {
          text: "Miesiąc",
          value: "month"
        }
      ]
    }
  },
  methods: {
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = '';
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    clickEvent(event) {
      this.$emit("clickEvent", event)
    },
    clickDate(event) {
      this.focus = event.date;
      this.type = 'day'
      this.$emit('clickDate', event);
    },
    clickMore(event) {
      this.$emit('clickMore', event);
    },
    clickDay(event) {
      this.$emit("clickDay", event);
    }
  },
  mounted() {
    this.$refs.calendar.checkChange();
    this.isInitialized = true;
  }
}
</script>
